import type { Component } from 'vue'

import { useUiKitConfig } from './useUiKitConfig'

type Navigate = (to: string) => unknown

const defaultNavigate: Navigate = (to) => window.location.assign(to)

export function useUiKitLink(): { linkComponent: Component | null, navigate: Navigate } {
  const config = useUiKitConfig()

  return {
    linkComponent: config.linkComponent || null,
    navigate: config.navigate || defaultNavigate,
  }
}
